export class FrameConnectionMock {
    showDialogChoice() {}
}
